import axios from "axios";
import { CorrBankType } from "../../../../guestUser/common/types/GuestCorrBankDetails";

export const createCorrBank = (
  corrBankDetails: CorrBankType,
  sessionId: string | null
) => {
  return axios
    .post(
      `${process.env.REACT_APP_BASE_URL}api/create/one/tradexwbench.customer_settlement_correspondent_bank`,
      {
        params: {
          context: {},
          data: corrBankDetails,
        },
      },
      {
        headers: {
          Authorization: `Bearer ${sessionId}`,
        },
      }
    )
    .then((response) => {
      return response;
    })
    .catch((err) => err);
};
